const GROUP_BY_RULES = {
    day: { max: 45, tooLong: 'balance-period_too_long_daily' },
    week: { min: 14, tooShort: 'balance-period_too_short_weekly', max: 364, tooLong: 'balance-period_too_long_weekly' },
    month: { min: 60, tooShort: 'balance-period_too_short_monthly' },
    quarter: { min: 180, tooShort: 'balance-period_too_short_quarterly' },
};

export function groupByBlockReason(groupBy, days) {
    const rule = GROUP_BY_RULES[groupBy];
    if (!rule) return null;
    if (rule.min && days < rule.min) return rule.tooShort;
    if (rule.max && days > rule.max) return rule.tooLong;
    return null;
}

export function isGroupByAllowed(groupBy, days) {
    return groupBy in GROUP_BY_RULES && groupByBlockReason(groupBy, days) === null;
}
